export enum FacetTypeEnum {
  HIERARCHICAL = 'hierarchical',
  RANGE = 'range',
  VALUE = 'value',
  BOOLEAN = 'boolean',
  SLIDER = 'slider',
}
